
 <!-- 楼宇租控 -->
<template>
  <div>
    <!-- 统计卡片 -->
    <div class="summaryCards-row">
      <div v-for="item in summaryCards" :key="item.label" class="stat-card">
        <div class="stat-label">{{ item.label }}</div>
        <div class="stat-value" :style="{ color: item.color }">
          {{ item.value }} <span class="unit">间</span>
        </div>
      </div>
    </div>

    <!-- 筛选选择 -->
    <div class="filter-bar">
      <span class="filter-label">选择楼栋：</span>
      <el-select
        v-model="selectedBuilding"
        size="small"
        placeholder="请选择"
        style="width: 200px"
        @change="buildingChange"
      >
        <el-option
          v-for="item in floorList"
          :label="item.name"
          :value="item.floorId"
          :key="item.floorId"
        />
      </el-select>
    </div>

    <!-- 图例 -->
    <div class="legend-bar">
      <span class="legend-title">图例：</span>
      <div v-for="item in statusMapping" :key="item.label" class="legend-item">
        <span
          class="legend-color"
          :style="{
            backgroundColor: item.bg,
            border: item.border ? '1px solid ' + item.border : 'none',
          }"
        ></span>
        <span class="legend-text">{{ item.label }}</span>
      </div>
    </div>

    <!-- 单元渲染内容 -->
    <div v-for="unit in unitList" :key="unit.unitId" class="unit-section">
      <div class="unit-header" @click="unit.expand = !unit.expand">
        <span>单元名称：{{ unit.unitNum }}</span>
        <i :class="unit.expand ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>

      <el-collapse-transition>
        <div v-show="unit.expand" class="unit-content">
          <!-- 楼层行 -->
          <div
            v-for="floor in unit.layerList"
            :key="floor.layer"
            class="floor-row"
          >
            <div class="floor-label">{{ floor.layer }}F</div>
            <div class="rooms-grid">
              <el-popover
                v-for="room in floor.roomList"
                :key="room.roomId"
                placement="right"
                width="160"
                trigger="hover"
                popper-class="room-popover"
              >
                <!-- Popup 内容 -->
                <div class="pop-content">
                  <p>房间号：{{ room.roomNum }}</p>
                  <p>面积：{{ room.builtUpArea }}㎡</p>
                  <p>状态：{{ _commonFormatter(room, "state") }}</p>
                  <p v-if="room.contract && room.contract.partyB">
                    租客：{{ _commonFormatter(room, "contract.partyB") }}
                  </p>
                  <p>到期：{{ _commonFormatter(room, "contract.endTime") }}</p>
                </div>

                <!-- 房间展示块 -->
                <div
                  slot="reference"
                  class="room-card"
                  :class="[
                    room.contract && room.contract.expiring
                      ? 'status-expiring'
                      : 'status-' + room.state,
                  ]"
                  @click="cellClick(floor, room)"
                >
                  <div class="room-no">{{ room.roomNum }}</div>
                  <div class="room-info">面积: {{ room.builtUpArea }}㎡</div>
                  <div class="room-info">
                    状态：{{ _commonFormatter(room, "state") }}
                  </div>
                  <div class="room-info" v-if="room.state == '2006'">
                    到期:{{ _commonFormatter(room, "contract.endTime") }}
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>

    <el-dialog
      :title="currentTitle + '- 房间详情'"
      :visible.sync="dialogVisible"
      width="40%"
      :max-height="800"
      :before-close="handleClose"
      custom-class="custom-room-dialog"
    >
      <leaseControlMapTab1Modal :details="sectionDetails" />
      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import { formatDate } from "../../../utils/dateUtil.js";
import {
  mapValuesToArray,
  commonFormatter,
  safeDivide,
  isEmptyValue,
} from "../../../utils/tool.js";
import leaseControlMapTab1Modal from "./leaseControlMapTab1Modal.vue";
const TAG = "楼宇租控";

export default {
  components: {
    leaseControlMapTab1Modal,
  },
  data() {
    return {
      currentTitle: "",
      // 控制弹窗是否显示
      dialogVisible: false,

      activeTab: "楼宇租控",
      // 页签数据
      tabs: ["楼宇租控", "车位租控", "广告位租控", "保租房租控", "铺位租控"],
      // 顶部统计数据
      summaryCards: [
        { label: "总房间数", value: "", color: "#909399", key: "total" },
        { label: "已出租", value: "", color: "#52c41a", key: "rentedCount" },
        {
          label: "空置可租",
          value: "",
          color: "#faad14",
          key: "availableCount",
        },
        { label: "已预订", value: "", color: "#1890ff", key: "reservedCount" },
        {
          label: "装修中",
          value: "",
          key: "renovatingCount",
          color: "#722ed1",
        },
        {
          label: "即将到期",
          value: "",
          color: "#f5222d",
          key: "expiringCount",
        },
      ],
      selectedBuilding: "",
      // 状态颜色映射表
      statusMapping: {
        rented: { label: "已出租", bg: "#52c41a", color: "#fff" },
        vacant: {
          label: "空置可租",
          bg: "#fff",
          border: "#dcdfe6",
          color: "#606266",
        },
        reserved: {
          label: "已预订",
          bg: "#fff",
          border: "#1890ff",
          color: "#1890ff",
        },
        decorating: { label: "装修中", bg: "#722ed1", color: "#fff" },
        expiring: { label: "即将到期", bg: "#f5222d", color: "#fff" },
      },
      // 详情模板
      sectionDetails: [
        {
          key: "baseInfo",
          show: true,
          title: "基本信息",
          items: [
            { key: "roomNum", label: "房间号", value: "" },
            { key: "state", label: "租赁状态", value: "" },
            { key: "builtUpArea", label: "面积", value: "" },
            { key: "unitPrice", label: "租金单价", value: "" },
            { key: "endTime", label: "到期日期", value: "", span: 2 },
          ],
        },
        // {
        //   show: false,
        //   title: "资源信息",
        //   items: [
        //     { key: "没有", label: "资源编号", value: "" },
        //     { key: "没有", label: "资源名称", value: "" },
        //     { key: "没有", label: "资源类型", value: "" },
        //     { key: "没有", label: "所属项目", value: "" },
        //   ],
        // },
        {
          key: "contract",
          show: true,
          title: "租客信息",
          items: [
            { key: "partyB", label: "租客名称", value: "", span: 2 },
            { key: "blink", label: "联系电话", value: "" },
            { key: "没有", label: "联系地址", value: "" },
          ],
        },
        {
          key: "contract", // 判断使用，可以重复
          show: true,
          title: "合同信息",
          items: [
            { key: "contractCode", label: "合同编号", value: "" },
            { key: "signingTime", label: "签约日期", value: "" },
            { key: "endTime", label: "到期日期", value: "" },
            { key: "没有", label: "付款方式", value: "" },
            { key: "roomRent", label: "月租金", value: "" },
            { key: "没有", label: "押金", value: "" },
            { key: "没有", label: "付款日", value: "" },
            { key: "没有", label: "缴费状态", value: "", isTag: true },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState("asset", ["floorList", "roomTotal", "unitList"]),
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("asset", [
      "queryBuildingRoomChartHandler", // 查询楼栋房间信息（按单元和楼层划分）
      "queryResourceWithAssetHandler", // 查询资源及资产信息（车位、广告、铺位）
      "statisticRoomStatusHandler", // 统计各租赁状态的房间数量
    ]),

    init() {
      const params = { assetCategory: "HOUSE" };
      this.queryBuildingRoomChartHandler(params).then((res) => {
        this.selectedBuilding = _.get(this.floorList, "[0].floorId");
        console.log(TAG, "init this.selectedBuilding=", this.selectedBuilding);
        console.log(TAG, "init this.unitList=", this.unitList);
      });
      this.statisticRoomStatusHandler(params).then((obj) => {
        this.summaryCards = mapValuesToArray(this.summaryCards, obj);
        console.log(TAG, "init this.summaryCards=", this.summaryCards);
      });
    },

    buildingChange() {
      this.queryBuildingRoomChartHandler({
        assetCategory: "HOUSE",
        floorId: this.selectedBuilding,
      }).then((res) => {
        console.log(TAG, "buildingChange this.unitList=", this.unitList);
      });
    },

    // 获取状态文本
    getStatusLabel(status) {
      return status;
    },

    _commonFormatter(row, field) {
      return commonFormatter(row, field);
    },

    //----------------------弹窗展示---------------------

    /**
     * 处理弹窗关闭操作
     */
    handleClose() {
      this.dialogVisible = false;
    },

    /**
     * 处理弹窗关闭操作
     */
    openDetail() {
      this.dialogVisible = true;
    },

    cellClick(floor, room) {
      console.log(TAG, "cellClick floor=", floor);
      console.log(TAG, "cellClick room=", room);
      this.currentTitle = _.get(room, "roomNum");

      this.openDetail();
      this.setDetail(room);
    },

    setDetail(item) {
      const cellObj = { ...item };
      const { state } = cellObj;
      const contract = _.get(cellObj, "contract");
      Object.assign(cellObj, contract, {
        state: commonFormatter(cellObj, "state"),
      }); // 合同里面也有state，使用外层的state

      const append = {
        unitPrice: safeDivide(
          _.get(cellObj, "roomRent") * 1,
          _.get(cellObj, "builtUpArea") * 1
        ),
        endTime: formatDate(_.get(cellObj, "endTime") || "", "yyyy-MM-dd"),
      };

      Object.assign(cellObj, append);

      console.log(TAG, "setDetail cellObj=", cellObj);

      _.each(this.sectionDetails, (detail) => {
        const items = _.get(detail, "items");
        const key = _.get(detail, "key");

        if (key == "contract" && isEmptyValue(contract)) {
          detail.show = false;
        } else {
          detail.show = true;
        }

        detail.items = mapValuesToArray(items, cellObj);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色变量定义 */
$bg-main: #f0f2f5; // 页面主背景
$color-green: #52c41a; // 已出租 (绿色)
$color-white: #ffffff; // 空置 (白色)
$color-blue: #1890ff; // 已预订 (蓝色)
$color-purple: #722ed1; // 装修中 (紫色)
$color-red: #f5222d; // 即将到期 (红色)
$border-light: #ebeef5; // 浅边框色
$text-secondary: #909399; // 次要文字颜色

.rent-control-container {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial;

  /* 顶部页签 */
  .tabs-header {
    margin-bottom: 16px;
  }

  /* 统计行布局 */
  .summaryCards-row {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .stat-card {
      flex: 1;
      min-width: 160px;
      background: #fff;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

      .stat-label {
        color: $text-secondary;
        font-size: 13px;
        margin-bottom: 8px;
      }
      .stat-value {
        font-size: 22px;
        font-weight: 500;
        .unit {
          font-size: 14px;
          margin-left: 4px;
        }
      }
    }
  }

  /* 筛选工具栏 */
  .filter-bar {
    background: #fff;
    padding: 12px 20px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid $border-light;
    text-align: left;
    .filter-label {
      font-size: 14px;
      color: #303133;
    }
  }

  /* 图例栏 */
  .legend-bar {
    background: #fff;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 13px;
    border-bottom: 1px solid $border-light;

    .legend-title {
      font-weight: bold;
    }
    .legend-item {
      display: flex;
      align-items: center;
      .legend-color {
        width: 14px;
        height: 14px;
        display: inline-block;
        margin-right: 6px;
        border-radius: 2px;
      }
    }
  }

  /* 单元区块 */
  .unit-section {
    margin-top: 16px;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;

    .unit-header {
      background: #f8f9fb;
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-weight: bold;
      border-bottom: 1px solid $border-light;
    }

    .unit-content {
      padding: 15px;
    }
  }

  /* 楼层行布局 */
  .floor-row {
    display: flex;
    margin-bottom: 10px;
    align-items: stretch;

    .floor-label {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #606266;
      background: #fafafa;
      border: 1px solid $border-light;
      border-right: none;
    }

    .rooms-grid {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(4, 1fr); // 响应式网格，一排4个
      gap: 8px;
      padding: 8px;
      border: 1px solid $border-light;
    }
  }

  /* 房间卡片样式定义 */
  .room-card {
    height: 70px;
    padding: 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    border: 1px solid transparent;

    .room-no {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .room-info {
      font-size: 14px;
      transform: scale(0.9);
      line-height: 1.2;
    }

    /* 状态颜色应用 */
    // 已经出租
    &.status-RENTED,
    &.status-2006,
    &.status-rented {
      background-color: $color-green;
      color: #fff;
    }

    // 空闲可租
    &.status-AVAILABLE,
    &.status-2001, // 已入住
    &.status-2002, // 未销售
    &.status-2003, // 已交房
    &.status-2005, // 已装修
    &.status-2004, // 未入住
    &.status-2004, // 未入住
    &.status-2007, // 已出售
    &.status-2008, // 空闲
    &.status-vacant {
      background-color: $color-white;
      border-color: #dcdfe6;
      border: 2px solid #dcdfe6;
      color: #606266;
    }

    // 装修中
    &.status-RENOVATING,
    &.status-2009,
    &.status-decorating {
      background-color: $color-purple;
      color: #fff;
    }

    // 已预定
    &.status-RESERVED,
    &.status-reserved {
      background-color: $color-white;
      border-color: $color-blue;
      color: $color-blue;
    }

    // 即将到期
    &.status-expiring {
      background-color: $color-red;
      color: #fff;
    }

    &:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      opacity: 0.9;
    }
  }
}

/* 弹出框内容样式 */
.pop-content {
  font-size: 12px;
  line-height: 1.8;
  p {
    margin: 0;
    color: #333;
  }
}

/* 响应式适配：移动端减小列数 */
@media (max-width: 992px) {
  .rent-control-container .floor-row .rooms-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>

<style>
/* 全局样式覆盖 Element UI */
.room-popover {
  background: rgba(0, 0, 0, 0.8) !important;
  color: #fff !important;
  border: none !important;
  padding: 10px !important;
}
.room-popover .pop-content p {
  color: #fff !important;
}
.room-popover .popper__arrow::after {
  border-right-color: rgba(0, 0, 0, 0.8) !important;
}
</style>

<style lang="scss" scoped>
/* =========== 颜色与全局变量的定义 =========== */
$color-text-main: #333333; /* 主要文字颜色 */
$color-text-label: #8c8c8c; /* 标签(Label)灰字颜色 */
$color-text-success: #67c23a; /* 已出租（成功）绿字颜色 */
$color-bg-white: #ffffff; /* 基础白色背景色 */
$color-border-line: #ebeef5; /* 表格基础边框颜色 */

// 标签样式变量
$color-tag-text: #606266; /* "未缴费" 等标签字体颜色 */
$color-tag-border: #dcdfe6; /* "未缴费" 边框颜色 */
$color-tag-bg: #f4f4f5; /* "未缴费" 背景颜色 */

// 字体与间距
$font-size-title: 15px; /* 模块标题字号 */
$font-size-base: 14px; /* 模块内容基础字号 */
$margin-section: 20px; /* 区块之间间距 */

.custom-room-dialog {
  max-height: 800;
  overflow: scroll;
  border: 1px solid red;
}
/* =========== 样式主题表 =========== */
.room-detail-container {
  // 覆盖 element-ui dialog 个别默认样式
  ::v-deep .custom-room-dialog {
    border-radius: 6px;

    .el-dialog__header {
      border-bottom: 1px solid $color-border-line;
      padding: 20px;
      .el-dialog__title {
        font-weight: bold;
        color: $color-text-main;
      }
    }

    .el-dialog__body {
      padding: 10px 20px 0 20px;
      border: 1px solid red;
      max-height: 70vh;
      overflow-y: auto; // 响应式保证高度不足时有滚动条
    }

    .el-dialog__footer {
      border-top: 1px solid $color-border-line;
      padding: 15px 20px;
    }
  }
}

.dialog-body {
  .detail-section {
    margin-bottom: $margin-section;

    // 区块标题样式
    .section-title {
      font-size: $font-size-title;
      font-weight: 600;
      color: $color-text-main;
      margin-bottom: 12px;
      margin-top: 8px;
    }

    // 统一定制 Description 的 Label 与 Content 样式
    ::v-deep .custom-descriptions {
      border-radius: 4px;
      overflow: hidden;

      .el-descriptions-item__label.is-bordered-label {
        background: $color-bg-white !important; // 使标签行背景为白底，一比一复刻
        color: $color-text-label;
        text-align: center;
        width: 120px;
        font-weight: normal;
      }

      .el-descriptions-item__content {
        color: $color-text-main;
        font-size: $font-size-base;
        padding-left: 20px;
      }
    }

    // "已出租" 绿色文本
    .status-success {
      color: $color-text-success;
    }

    // "未缴费" 自定义小标签边框样式
    .status-tag {
      display: inline-block;
      padding: 2px 10px;
      font-size: 12px;
      color: $color-tag-text;
      background-color: $color-tag-bg;
      border: 1px solid $color-tag-border;
      border-radius: 2px;
    }
  }
}

/* ============ 响应式调整 ============ */
@media screen and (max-width: 768px) {
  // 窄屏幕时调整弹窗宽度至近乎满屏
  ::v-deep .custom-room-dialog {
    width: 95% !important;
  }
  .dialog-body {
    .detail-section {
      ::v-deep .custom-descriptions {
        .el-descriptions-item__label.is-bordered-label {
          width: 90px; // 小屏幕缩短表头占位宽度
        }
        .el-descriptions-item__content {
          padding-left: 10px;
        }
      }
    }
  }
}

::v-deep .custom-room-dialog {
  .el-dialog__body {
    // border: 1px solid red;
    padding-top: 0px;
  }
}

::v-deep .section-title {
  text-align: left;
}

::v-deep .detail-section {
  border: 1px solid #e2e8f0;
  padding: 20px;
  border-radius: 10px;
}

::v-deep .el-dialog.custom-room-dialog {
  margin-top: 20px !important;
}
</style>
